import { Component, OnInit } from '@angular/core';
import { InputBase } from '../input-base';

@Component({
  selector: 'spaq-input-sms',
  templateUrl: './input-sms.component.html',
  styleUrls: ['./input-sms.component.css']
})
export class InputSmsComponent extends InputBase implements OnInit {

  mask = '(000) 000-0000';

  constructor() { super(); }


  ngOnInit() {
    if (!this.label) {
      this.label = 'Numéro de téléphone';
    }

    if (!this.name) {
      this.name = 'phoneNumber';
    }
  }

}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/shared/form/input-sms/input-sms.component.ts